import { MyReduxStore } from 'ha/myredux/types';

import { STATE_NAME } from './constants';
import HomePage from './containers/HomePage';
import reducer from './reducer';

export default (store: MyReduxStore): React.ReactNode => {
  store.injectAsyncReducer(STATE_NAME, reducer);
  return HomePage;
};
